import { ReactNode, useContext, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  faChevronLeft,
  faChevronRight,
  faChartLine,
  faClipboardCheck,
  faRightFromBracket,
  faRotate,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppDataContext, ctxDefinition } from "./ctx";
import { BrandButtonWhite } from "./form/buttons";
import "./userMenu.scss";

interface UserMenuProps {
  children: ReactNode;
}

const UserMenu = ({ children }: UserMenuProps) => {
  const [expanded, setExpanded] = useState(true);
  const { clearSession } = useContext(AppDataContext) as ctxDefinition;
  const navigate = useNavigate();

  const logout = () => {
    clearSession();
    navigate("/login", { replace: true });
  };

  return (
    <>
      <aside
        className={`testTakerSidebar${expanded ? "" : " isCollapsed"}`}
        aria-label="Test taker navigation"
      >
        <div className="testTakerMenuHeader">
          {expanded && <span className="testTakerMenuTitle">MY ACCOUNT</span>}
          <button
            className="testTakerMenuToggle"
            type="button"
            onClick={() => setExpanded((value) => !value)}
            aria-label={expanded ? "Collapse menu" : "Expand menu"}
            aria-expanded={expanded}
          >
            <FontAwesomeIcon icon={expanded ? faChevronLeft : faChevronRight} />
          </button>
        </div>
        <nav className="testTakerMenuLinks">
          <NavLink to="/exam-results" className="testTakerMenuLink">
            <FontAwesomeIcon icon={faChartLine} />
            {expanded && <span>Latest Exam</span>}
          </NavLink>
          <NavLink to="/completed-exams" className="testTakerMenuLink">
            <FontAwesomeIcon icon={faClipboardCheck} />
            {expanded && <span>Completed Exams</span>}
          </NavLink>
          <NavLink to="/start-new-exam" className="testTakerMenuLink">
            <FontAwesomeIcon icon={faRotate} />
            {expanded && <span>Start New Exam</span>}
          </NavLink>
        </nav>
        <div className="testTakerMenuLogout">
          <BrandButtonWhite
            variant="outlined"
            onClick={logout}
            aria-label="Logout"
          >
            <FontAwesomeIcon icon={faRightFromBracket} />
            {expanded && <span>Logout</span>}
          </BrandButtonWhite>
        </div>
      </aside>
      <main className="testTakerMain">{children}</main>
    </>
  );
};

export default UserMenu;
